import AnimatedBg from './AnimatedBg';
import { View } from 'foundations-components/components/View';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightContainerSkeleton = ({
  objectTypeId,
  withBlockPadding = true
}) => {
  const {
    showAvatar,
    numberOfPropertis
  } = useMemo(() => {
    if (objectTypeId === CONTACT_TYPE_ID || objectTypeId === COMPANY_TYPE_ID) {
      return {
        showAvatar: true,
        numberOfPropertis: 2
      };
    }
    if (objectTypeId === DEAL_TYPE_ID) {
      return {
        showAvatar: false,
        numberOfPropertis: 4
      };
    }
    if (objectTypeId === TICKET_TYPE_ID) {
      return {
        showAvatar: false,
        numberOfPropertis: 3
      };
    }
    return {
      showAvatar: false,
      numberOfPropertis: 2
    };
  }, [objectTypeId]);
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: withBlockPadding ? '400' : '0',
    children: /*#__PURE__*/_jsxs(Media, {
      paddingBlockStart: "25",
      paddingBlockEnd: "100",
      children: [showAvatar && /*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(View, {
          blockSize: "72px",
          inlineSize: "72px",
          minBlockSize: "72px",
          borderRadius: "full",
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(AnimatedBg, {})
        })
      }), /*#__PURE__*/_jsxs(MediaBody, {
        children: [/*#__PURE__*/_jsx(View, {
          maxInlineSize: "180px",
          blockSize: "26px",
          marginBlockStart: "100",
          borderRadius: "100",
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(AnimatedBg, {})
        }), Array.from({
          length: numberOfPropertis
        }, (_, index) => /*#__PURE__*/_jsx(View, {
          maxInlineSize: index % 2 === 0 ? '220px' : '200px',
          blockSize: "16px",
          marginBlockStart: "250",
          borderRadius: "100",
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(AnimatedBg, {})
        }, `${objectTypeId}-property-${index}`))]
      })]
    })
  });
};
export default HighlightContainerSkeleton;